import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AtokuUser } from '../../../models/atoku-user.model';

@Component({
    selector: 'app-give-access-dialog',
    templateUrl: './give-access-dialog.component.html',
    styleUrls: ['./give-access-dialog.component.scss']
})
export class GiveAccessDialogComponent implements OnInit {
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<GiveAccessDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AtokuUser,
        private fb: FormBuilder
    ) {
        const now = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(now.getDate() + 1);

        this.form = this.fb.group({
            startDate: [now, Validators.required],
            startTime: ['08:00', Validators.required],
            endDate: [tomorrow, Validators.required],
            endTime: ['17:00', Validators.required]
        });
    }

    ngOnInit(): void {
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSave(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.value);
        }
    }
}
